import { Injectable, Type } from '@angular/core';
import { BaseApiService } from '@kinet-open-network/client/core/api-client';
import { Fee } from '../models/fee.model';

@Injectable({
  providedIn: 'root',
})
export class FeesService extends BaseApiService<Fee> {
  override model: Type<Fee> = Fee;

  override get endpoint(): string {
    return '/fees';
  }
}
